import { toJS, observable, action } from "mobx";
import { httpClient } from "../../utils/httpClient";
import api from "../../config/api";
import {
  formatTopCateTree,
  formatCateTable,
  formatHomeOperateCateTree,
  formatStoreCateTree,
} from "../../utils/common";
const { shop } = api;

// 有下级分类的时候添加children
const formatChildren = (list) => {
  list.map((val) => {
    if (val.subCount > 0) {
      val.children = [];
    }
    return val;
  });
};

class CateStore {
  @observable cateList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  @observable cateTree = [];

  // 获取root分类列表
  @action async getRootCateList(params) {
    const { data } = await httpClient.post(shop.GET_CATE_LIST, { ...params });
    formatChildren(data.list);

    this.cateList = {
      list: formatCateTable(data.list),
      pages: {
        total: data.total,
        pageSize: params.pageSize,
        currentPage: data.page,
      },
    };
  }

  // 获取子分类
  @action async getSubCateList(params) {
    const { data } = await httpClient.post(shop.GET_CATE_LIST, { ...params });
    formatChildren(data.list);

    // 匹配拼接catelist
    const list = [...this.cateList.list];
    list.map((i) => {
      if (i.categoryId === params.parentId) {
        i.children = formatCateTable(data.list, params.record);
      } else if (i.children) {
        i.children.map((j) => {
          if (j.categoryId === params.parentId) {
            j.children = formatCateTable(data.list, params.record);
          }
        });
      }
    });

    this.cateList = {
      list: list,
      pages: this.cateList.pages,
    };
    return data;
  }

  // 新增分类-获取顶级分类
  @action async getTopCateTree(params) {
    const { data } = await httpClient.post(shop.GET_CATE_TREE, {
      page: 1,
      pageSize: 100,
      parentId: 0,
    });
    let newData = JSON.parse(
      JSON.stringify(data?.list).replace(/childNodes/g, "children")
    );

    this.cateTree = [
      { id: "00", pId: 0, key: 0, title: "顶级分类", value: "0" },
      ...formatTopCateTree(newData),
    ];
  }

  // 获取全部分类树
  @action async getCateTree(params = {}) {
    const { allSelectable = false } = params;
    const { data } = await httpClient.post(shop.GET_CATE_TREE, {
      page: 1,
      pageSize: 100,
      parentId: 0,
    });
    let newData = JSON.parse(
      JSON.stringify(data?.list)?.replace(/childNodes/g, "children")
    );

    this.cateTree = formatStoreCateTree(newData, allSelectable);
    return data;
  }

  // 新增分类
  @action updateCate(params) {
    return params.isAdd
      ? httpClient.post(shop.ADD_CATE, { ...params })
      : httpClient.post(shop.EDIT_CATE, { ...params });
  }

  // 删除分类
  @action delCate(params) {
    return httpClient.post(shop.DEL_CATE, { ...params });
  }

  // 改变分类排序
  @action changeCateSort(params) {
    return httpClient.post(shop.CHANGE_CATE_SORT, { ...params });
  }

  // 获取分类下的商品数
  @action async getCateGoodsNum(params, index) {
    const { data } = await httpClient.post(shop.GET_CATE_GOOGS_NUM, {
      ...params,
    });
    let _list = this.cateList.list;

    // 更改state.goodsCountNum 以更新页面展示
    let n = 0;
    function findItem(list, n) {
      return list[index[n]];
    }
    function setItem(item, i) {
      if (item.categoryLevel === index.length) {
        item.goodsCountNum = data.toString();
      } else {
        item.children[index[i + 1]] = setItem(
          findItem(item.children, i + 1),
          i + 1
        );
      }
      return item;
    }
    _list[index[0]] = setItem(findItem(_list, n), n);

    this.cateList.list = toJS(_list);
  }
}

export default new CateStore();
